import { svg } from 'lit';

const symbol = svg`<svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8.1l4.7 4.8L15.6 3" stroke="currentcolor"/></svg>`;

export { symbol as default };
